<template>
  <div />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { dispatchCustomEventGlobally } from 'www/utils'
import I18NextVue from 'i18next'
import useChipsStore from 'www/vue_components/common/TheFilters/lpu/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import updateLpuListPage from 'www/vue_components/common/TheFilters/lpu/functions/updateLpuListPage'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()

watch(
  () => filtersStore.filters.isHighRating,
  () => {
    chipsStore.updateHighRatingChip({
      name: t('Высокий рейтинг', options.value),
      isActive: filtersStore.filters.isHighRating !== undefined,
      isVisible: filtersStore.filters.isHighRating !== undefined,
      async onReset() {
        filtersStore.updateFilters({ isHighRating: undefined })

        await updateLpuListPage()

        dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
          upper: true,
          message: t('Фильтр сброшен', options.value),
        })
      },
    })
  },
  { immediate: true },
)
</script>
